/* EditorLmrbComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./EditorLmrbRenderer");

class EditorLmrbComponent extends EventEmitter {
    constructor(logger, editorLayout, userSession) {
        super();
        this._logger = logger;
        this._userSession = userSession;
        this._editorLayout = editorLayout;
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {
        this._userSession.on(
            "OrganizationChange",
            (this._onOrgChange = this._onOrgChange.bind(this))
        );
    }

    _unregisterListeners() {
        this._userSession.removeListener("OrganizationChange", this._onOrgChange);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(() => {
            this._renderer = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */

    /*******************************************/
    _onOrgChange() {
        this._editorLayout.closeAllEditors();
    }

    onContainerSizeChange() {
        this._editorLayout.resizeContainer();
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = EditorLmrbComponent;
EditorLmrbComponent.$inject = ["$teve.logger", "EditorLayout.EditorLayout", "$teve.userSession"];
EditorLmrbComponent.$supportedQuadrants = ["middle"];
EditorLmrbComponent.$defaultQuadrants = ["middle"];
EditorLmrbComponent.$iconRepoName = "branding.control";
EditorLmrbComponent.$openedByDefault = true;
